
export class SkapaArbetsorderData {
    anskaffningsForm: string;
    namn: string;
    hamtplatsId: number;
    lagerplatsId: number;
    ckleverantorId: number;
    transportforetagId: number;
    batId: string;
    avgangsmatning?: boolean;
    startDatum: Date;
    slutDatum: Date;
    avgangshamnId?: number;
    medBil?: boolean;
    mottagningsplatsAvgangshamnId?: number;
    kundId: boolean;
    transportslag: string;
    constructor() {
        this.anskaffningsForm = undefined;
        this.namn = undefined;
        this.hamtplatsId = undefined;
        this.lagerplatsId = undefined;
        this.ckleverantorId = undefined;
        this.batId = undefined;
        this.startDatum = undefined;
        this.slutDatum = undefined;
        this.transportforetagId = undefined;
        this.avgangsmatning = undefined;
        this.avgangshamnId = undefined;
        this.kundId = undefined;
        this.transportslag = undefined;
        this.mottagningsplatsAvgangshamnId = undefined;
        this.medBil = undefined;
    }
}
